Copyright 2022 Bio-Conversion Databank Foundation Licensed under the Apache
License, Version 2.0 (the "License"); you may not use this file except in
compliance with the License. You may obtain a copy of the License at
http://www.apache.org/licenses/LICENSE-2.0 Unless required by applicable law or
agreed to in writing, software distributed under the License is distributed on
an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
or implied. See the License for the specific language governing permissions and
limitations under the License

<template>
  <v-container fluid fill-height>
    <v-row align="center">
      <v-spacer v-if="!showPicture" />
      <v-col :cols="showPicture ? 4 : 8">
        <v-card flat align="center">
          <a href="https://www.bio-conversion.org/" target="_blank">
            <v-img
              src="../../assets/biodf/BioDF Logo with Text.png"
              max-height="100"
              max-width="200"
              class="mx-auto mb-11"
            >
            </v-img>
          </a>
          <p v-if="!showPicture" class="optional-message">
            Please use a larger screen to experience the maximizers full
            capability
          </p>
          <v-card-title
            class="justify-center text-h5 font-weight-bold primary--text"
            >Maximizer Portal</v-card-title
          >
          <slot></slot>
        </v-card>
      </v-col>
      <v-spacer v-if="!showPicture" />
      <v-col cols="8" v-if="showPicture">
        <v-img :src="getBackground" width="100%" class="pa-0 ma-0 image">
        </v-img>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'LoginCard',
  data() {
    return {
      smallWindowSize: 800,
      showPicture: true,
    };
  },
  computed: {
    getInnerWidth() {
      console.log(window.innerWidth);
      return window.innerWidth;
    },

    getBackground() {
      // still illegal access to pictures
      const pictures = [
        'https://aaqr.org/images/article_images/2019/feature/18-12-0467.jpg',
        'https://thumbor.forbes.com/thumbor/960x0/https%3A%2F%2Fspecials-images.forbesimg.com%2Fdam%2Fimageserve%2F1148301788%2F960x0.jpg%3Ffit%3Dscale',
        'https://images.immediate.co.uk/production/volatile/sites/4/2018/07/iStock_000021655524_Large-a2de642.jpg?webp=true&quality=90&resize=940%2C399',
        'https://images.pexels.com/photos/3854025/pexels-photo-3854025.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
        'https://images.pexels.com/photos/87771/animal-blue-creature-danger-87771.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
        'https://images.pexels.com/photos/2765872/pexels-photo-2765872.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
      ];
      const random = Math.floor(Math.random() * pictures.length);
      return pictures[random];
    },
  },
  created() {
    console.log(this.showPicture);
  },
  methods: {
    handleResize() {
      // Recalculate showPicture when window is resized
      this.showPicture = window.innerWidth >= this.smallWindowSize;
      console.log(this.showPicture);
      this.$forceUpdate();
    },
  },
  mounted() {
    this.showPicture = window.innerWidth >= this.smallWindowSize;
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style>
.image {
  height: 97vh;
}
.optional-message {
  font-style: italic;
  font-size: 13px;
}
</style>
